module.exports = __webpack_public_path__ + "img/car_rear_left.19eda776.svg";